/** Fixed values for the whole portal. Environment-specific values live in src/config. */

/** Sent on every API call: the API requires it for cookie-signed changes (CSRF protection, API.md §2). */
export const REQUESTED_WITH = { header: "X-Requested-With", value: "brocoly-vendor-web" } as const;

/** Display preference only (not user data, so it may live in localStorage). index.html reads the same key. */
export const THEME_STORAGE_KEY = "brocoly.theme";

/** Whether the desktop sidebar is collapsed to icons (a display preference, kept in this browser). */
export const SIDEBAR_STORAGE_KEY = "brocoly.sidebar";

/** How long the brand-team list stays fresh: it changes only when someone joins, leaves or is re-roled. */
export const MY_BRANDS_STALE_MS = 5 * 60_000;

/** The dispatch sheet reloads this often while open, so several people working on it see each other's marks. */
export const DISPATCH_REFRESH_MS = 30_000;

/** The notification bell checks for new messages this often (and whenever the tab comes back into focus). */
export const NOTIFICATIONS_REFRESH_MS = 60_000;

/** The API takes at most this many meals per dispatched / delivered call; bigger selections go in batches. */
export const DISPATCH_BATCH_SIZE = 500;

/** Server data in memory only (TanStack Query): fresh for 30 s, dropped 5 min after the last screen using it. */
export const QUERY_DEFAULTS = {
  staleTimeMs: 30_000,
  gcTimeMs: 5 * 60_000,
  /** Retries for reads that failed on the network or a 5xx (never 4xx: retrying can't fix those). */
  maxRetries: 2,
} as const;

/**
 * Maps for a delivery: "Open in Maps" at the customer's exact spot (saved with their agreement), else "Search in
 * Maps" for the typed address. Google Maps' public search link, which opens the Maps app on phones. No API key,
 * nothing sent until the link is tapped.
 */
export const MAPS_SEARCH_URL = "https://www.google.com/maps/search/?api=1&query=";

/** Money is shown for India: ₹ and Indian digit grouping. */
export const LOCALE = "en-IN";
export const CURRENCY = "INR";

/** The API's reporting time zone (REPORTING_TIMEZONE, default IST): months and days in reports are in it. */
export const REPORTING_TIMEZONE = "Asia/Kolkata";
